<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtxt1"><a id="page_v"></a>Also by Alan Warner</p>
<p class="fmtxt1"><em>Morvern Callar</em></p>
<p class="fmtxt"><em>These Demented Lands</em></p>
<p class="fmtxt"><em>The Sopranos/Our Ladies</em></p>
<p class="fmtxt"><em>The Man Who Walks</em></p>
<p class="fmtxt"><em>The Worms Can Carry Me to Heaven</em></p>
<p class="fmtxt"><em>The Stars in the Bright Sky</em></p>
<p class="fmtxt"><em>The Deadman’s Pedal</em></p>
<p class="fmtxt"><em>Their Lips Talk of Mischief</em></p>
<p class="fmtxt"><em>Kitchenly 434</em><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?79d5c1d6